const QUICK_LINKS = ['Home', 'About', 'Services', 'Reviews', 'Gallery', 'FAQ', 'Contact'];
const SERVICES_LINKS = [
  'Full Rewires', 'New Installations', 'Lighting Design', 'Fuse Board Upgrades',
  'EV Chargers', 'Fault Finding', 'Commercial', 'EICR Reports',
];

export default function Footer() {
  const scrollTo = (id: string) => {
    document.getElementById(id.toLowerCase())?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#050E1A] border-t border-[#C8A96A]/15">
      {/* Top CTA bar */}
      <div className="border-b border-[#C8A96A]/10" style={{ background: 'linear-gradient(135deg, #0A1628, #0D1E35)' }}>
        <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="font-playfair text-2xl md:text-3xl font-bold text-white">
              Ready to get started?{' '}
              <span className="bg-gradient-to-r from-[#C8A96A] to-[#E0C78A] bg-clip-text text-transparent">
                Call us today.
              </span>
            </h3>
            <p className="text-white/50 text-sm mt-1">
              We provide a free, no-obligation quote before commencing any work.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:01529265060"
              className="flex items-center gap-2 bg-gradient-to-r from-[#C8A96A] to-[#A8894F] hover:from-[#E0C78A] hover:to-[#C8A96A] text-black font-bold px-6 py-3 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              01529 265060
            </a>
            <button
              onClick={() => scrollTo('contact')}
              className="flex items-center gap-2 border border-[#C8A96A]/40 text-[#C8A96A] hover:bg-[#C8A96A]/10 font-medium px-6 py-3 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line" />
              Email Us
            </button>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/00423dcc-69f9-4748-ac0c-c15d54e5586b/90758309-4e57-4704-ada6-1299ec143e1f_3eb45589-c339-4fd1-9e2d-32cca06dacf9-removebg-preview.png?v=2a77e748ecd680d6c594c6350bb285eb"
                alt="Quantum Electrical Services Logo"
                className="w-14 h-14 object-contain"
                style={{ filter: 'drop-shadow(0 0 8px rgba(200,169,106,0.4))' }}
              />
              <div>
                <p className="text-[#C8A96A] font-bold text-sm tracking-widest uppercase">Quantum</p>
                <p className="text-white/60 text-xs tracking-wider uppercase">Electrical Services</p>
              </div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed mb-5">
              NAPIT registered electricians serving Sleaford &amp; Lincolnshire. Quality work, transparent pricing.
            </p>
            <div className="flex gap-3">
              {[
                { icon: 'ri-google-fill', href: 'https://share.google/wBdMPYxVfjdefwkN9' },
                { icon: 'ri-facebook-fill', href: '#' },
                { icon: 'ri-instagram-line', href: '#' },
              ].map(({ icon, href }) => (
                <a
                  key={icon}
                  href={href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center border border-[#C8A96A]/25 text-[#C8A96A]/70 hover:text-[#C8A96A] hover:border-[#C8A96A]/60 hover:bg-[#C8A96A]/10 rounded-full transition-all duration-300 cursor-pointer"
                >
                  <i className={`${icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-[#C8A96A] font-semibold text-sm uppercase tracking-wider mb-5">
              <a id="footer-nav" href="#home">Quick Links</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {QUICK_LINKS.map((link) => (
                <li key={link}>
                  <button
                    onClick={() => scrollTo(link.toLowerCase())}
                    className="text-white/50 hover:text-[#E0C78A] text-sm transition-colors duration-200 cursor-pointer flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-[#C8A96A]/50 group-hover:text-[#C8A96A] text-xs transition-colors duration-200" />
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#C8A96A] font-semibold text-sm uppercase tracking-wider mb-5">Services</h4>
            <ul className="flex flex-col gap-2.5">
              {SERVICES_LINKS.map((svc) => (
                <li key={svc}>
                  <button
                    onClick={() => scrollTo('services')}
                    className="text-white/50 hover:text-[#E0C78A] text-sm transition-colors duration-200 cursor-pointer flex items-center gap-2 group"
                  >
                    <i className="ri-arrow-right-s-line text-[#C8A96A]/50 group-hover:text-[#C8A96A] text-xs transition-colors duration-200" />
                    {svc}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#C8A96A] font-semibold text-sm uppercase tracking-wider mb-5">Contact</h4>
            <div className="flex flex-col gap-4">
              {[
                { icon: 'ri-phone-fill', text: '01529 265060', href: 'tel:01529265060' },
                { icon: 'ri-mail-fill', text: 'info@quantum-electrical.uk', href: 'mailto:info@quantum-electrical.uk' },
                { icon: 'ri-map-pin-2-fill', text: 'Sleaford, Lincolnshire NG34', href: '#' },
                { icon: 'ri-time-fill', text: 'Mon–Sat · 8am–6pm', href: '#' },
              ].map(({ icon, text, href }) => (
                <a
                  key={text}
                  href={href}
                  className="flex items-start gap-3 group cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className={`${icon} text-[#C8A96A]/60 group-hover:text-[#C8A96A] text-sm transition-colors duration-200`} />
                  </div>
                  <span className="text-white/50 group-hover:text-white/70 text-sm leading-snug transition-colors duration-200">
                    {text}
                  </span>
                </a>
              ))}
            </div>

            {/* Certs */}
            <div className="mt-6 flex flex-wrap gap-2">
              {['NAPIT', 'Part P', 'OLEV', '18th Ed.'].map((c) => (
                <span
                  key={c}
                  className="border border-[#C8A96A]/25 text-[#C8A96A]/70 text-xs px-2.5 py-1 rounded-full"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#C8A96A]/25 to-transparent mt-12 mb-7" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-xs">
            &copy; {new Date().getFullYear()}{' '}
            <strong className="text-[#C8A96A]/60">Quantum Electrical Services</strong>. All rights reserved. Sleaford, Lincolnshire.
          </p>
          <p className="text-white/20 text-xs">
            2-7 St Vincents, Sleaford NG34 · NAPIT Registered
          </p>
        </div>
      </div>
    </footer>
  );
}
